import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = new FormData();
    form.append('username', username);
    form.append('password', password);

    try {
      const res = await fetch('/privateZone/check_login.php', {
        method: 'POST',
        credentials: 'include',
        body: form,
      });
      if (res.ok) {
        navigate('/');
      } else {
        setError('Identifiant ou mot de passe incorrect');
      }
    } catch {
      setError('Erreur de connexion');
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h2>ACCÈS PRIVÉ</h2>
        {error && <p className="login-error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            placeholder="Identifiant"
            required
            autoComplete="username"
          />
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Mot de passe"
            required
            autoComplete="current-password"
          />
          <button type="submit">ENTRER</button>
        </form>
      </div>
    </div>
  );
};

export default Login;
